let code = 'cosecgestao';
let codeAPI = 'cosec';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};